<script>
    import { ModuleStore } from "../stores";

    let moduleInfo = {}
    ModuleStore.subscribe((data) => {moduleInfo = data})

    let inputValue = "Replace this with the full path to input folder or URL (check the tutorial page)"

    let serverOutput = ""

    let currentProgress = "0/?"

    const sendRequestToServer = async (thisServer, thisMessage, thisContent) => {
        const response = await fetch(thisServer, {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({content: thisContent, message: thisMessage})
        })
        
        const output = await response.json()

        return output
    }

    const downloadModule = async () => {
        //alert("Module Downloading")
        console.log("download starting now")

        let getProgressInterval = setInterval(async () => {
            let currentProgress = await sendRequestToServer("http://localhost:14366/", "get current progress", "no content")
            let currentStatus = currentProgress.split("-")[0]
            let currentPercentage = Number(currentProgress.split("-")[1])

            if (currentStatus = "unzipping") {
                console.log(currentProgress)
                if (currentPercentage == 100) {
                    clearInterval(getProgressInterval);
                }
            }
            else {
                console.log(currentProgress)
            }

        }, 1000);

        // let fileURL = "https://filedownload.sfo3.cdn.digitaloceanspaces.com/Sugoi-Translator-Toolkit-V5.0-Public.rar"
        let fileURL = "https://filedownload.sfo3.cdn.digitaloceanspaces.com/waifu2x-ncnn-vulkan-20220728-windows.zip"
        // let fileURL = "https://filedownload.sfo3.cdn.digitaloceanspaces.com/FlipImage.rar"

        let result = await sendRequestToServer("http://localhost:14366/", "download file", fileURL)
        console.log(result)
    }

    const processData = async () => {
        console.log("Processing start now")

        let getProgressInterval = setInterval(async () => {
            let serverCurrentProgress = await sendRequestToServer(moduleInfo.server, "get current progress", "no content")
            let currentNumber = serverCurrentProgress.split("/")[0]
            let totalNumber = serverCurrentProgress.split("/")[1]

            if (currentNumber == totalNumber) {
                clearInterval(getProgressInterval);
                currentProgress = serverCurrentProgress
            }
            else {
                currentProgress = serverCurrentProgress
            }

        }, 1000);

        let result = await sendRequestToServer(moduleInfo.server, moduleInfo.message_to_server, inputValue)
        serverOutput = result
    }

    let startServerButtonDisabled = false
    let closeServerButtonDisabled = true

    const flipServerCloseStart = () => {
        startServerButtonDisabled = !startServerButtonDisabled
        closeServerButtonDisabled = !closeServerButtonDisabled
    }

    const startServer = async () => {
        let serverCurrentProgress = await sendRequestToServer("http://localhost:14366/", "start server", moduleInfo.name)
        console.log(serverCurrentProgress)
        flipServerCloseStart()
    }

    const closeServer = async () => {
        flipServerCloseStart()
        await sendRequestToServer("http://localhost:14366/", "close server", moduleInfo.name)
    }

</script>

<h1>{moduleInfo.name}</h1>
<button on:click={() => {downloadModule()}} disabled="true">Download</button>
<button on:click={async () => {await startServer()}} disabled={startServerButtonDisabled}>Start Server</button>
<button on:click={() => {processData()}}>Process</button>
<button on:click={() => {closeServer()}} disabled={closeServerButtonDisabled}>Close Server</button>

<h3>Input Path:</h3>
<div class="textInputBox" contenteditable="true" bind:innerHTML={inputValue}></div>

<h3>Progress: {currentProgress}</h3>
<h3>Result Path:</h3>
<div class="textInputBox" contenteditable="false" bind:innerHTML={serverOutput}></div>

<h3>Note: {moduleInfo.note}</h3>

<h3>Input: {moduleInfo.input}</h3>
<h3>Output: {moduleInfo.output}</h3>

<style>
    .textInputBox {
        width: 1000px;
        height: 50px;
        background-color: aquamarine;
        margin: 5px
    }
</style>